export default class UpdateWorkTypeError extends Error {

}
